import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login.vue');
const PasswordRemind = () => import(/* webpackChunkName: "password.remind" */ '@/views/PasswordRemind.vue');
const PasswordReset = () => import(/* webpackChunkName: "password.reset" */ '@/views/PasswordReset.vue');

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/Dashboard.vue"),
      meta: {
        auth: true,
        title: "Dashboard",
      },
    },
    {
      path: "/wideband",
      component: () =>
        import(
          /* webpackChunkName: "wideband-orders" */ "@/views/wideband/Index.vue"
        ),
      children: [
        {
          path: "orders/outstanding",
          name: "wideband.orders.outstanding",
          component: () =>
            import(
              /* webpackChunkName: "wideband-orders" */ "@/views/wideband/OutstandingOrders.vue"
            ),
          meta: {
            auth: true,
            title: "Wideband Outstanding Orders",
            label: "Outstanding Orders",
            permission: "Manage Wideband Orders",
          },
        },
        {
          path: "orders/closed",
          name: "wideband.orders.closed",
          component: () =>
            import(
              /* webpackChunkName: "wideband-orders" */ "@/views/wideband/ClosedOrders.vue"
            ),
          meta: {
            auth: true,
            title: "Wideband Closed Orders",
            label: "Closed Orders",
            permission: "Manage Wideband Orders",
          },
        },
        {
          path: "products/active",
          name: "wideband.products.active",
          component: () => import("@/views/wideband/ActiveProducts.vue"),
          meta: {
            auth: true,
            title: "Wideband Active Products",
            label: "Active Products",
            permission: "Manage Wideband Products",
          },
        },
        {
          path: "products/closed",
          name: "wideband.products.closed",
          component: () => import("@/views/wideband/ClosedProducts.vue"),
          meta: {
            auth: true,
            title: "Wideband Closed Products",
            label: "Closed Products",
            permission: "Manage Wideband Products",
          },
        },
        {
          path: "sq-by-address",
          meta: {
            label: "SQ By Address",
            icon: () => import("@/icons/Settings.vue"),
            modal: () =>
              import("@/components/wideband/modals/ServiceQualification.vue"),
            permission: "Manage Wideband Service Qualification",
          },
        },
        {
          path: "sq-by-location-id",
          meta: {
            label: "SQ By Location ID",
            icon: () => import("@/icons/Settings.vue"),
            modal: () =>
              import("@/components/wideband/modals/ServiceQualification.vue"),
            permission: "Manage Wideband Service Qualification",
          },
        },
        {
          path: "tests/outstanding",
          name: "wideband.tests.outstanding",
          component: () => import("@/views/wideband/OutstandingTests.vue"),
          meta: {
            auth: true,
            title: "Wideband Outstanding Tests",
            label: "Outstanding Tests",
            permission: "Manage Wideband Service Testing",
          },
        },
        {
          path: "tests/closed",
          name: "wideband.tests.closed",
          component: () => import("@/views/wideband/ClosedTests.vue"),
          meta: {
            auth: true,
            title: "Wideband Closed Tests",
            label: "Closed Tests",
            permission: "Manage Wideband Service Testing",
          },
        },
        {
          path: "tickets/outstanding",
          name: "wideband.tickets.outstanding",
          component: () => import("@/views/wideband/OutstandingTickets.vue"),
          meta: {
            auth: true,
            title: "Wideband Outstanding Tickets",
            label: "Outstanding Tickets",
            permission: "Manage Wideband Trouble Tickets",
          },
        },
        {
          path: "tickets/closed",
          name: "wideband.tickets.closed",
          component: () => import("@/views/wideband/ClosedTickets.vue"),
          meta: {
            auth: true,
            title: "Wideband Closed Tickets",
            label: "Closed Tickets",
            permission: "Manage Wideband Trouble Tickets",
          },
        },
        {
          path: "not-rfs-locs",
          name: "wideband.not-rfs-locs.index",
          component: () => import("@/views/wideband/NotRFSLocations.vue"),
          meta: {
            auth: true,
            title: "Wideband Not RFS Locations",
            label: "Not RFS Locations",
            permission: "Manage Wideband Orders",
          },
        },
      ],
      meta: {
        auth: true,
        title: "Wideband",
        label: "Wideband",
        group: "leftSidebar",
      },
    },
    {
      path: "/whois",
      meta: {
        label: "WHOIS",
        modal: () => import("@/views/whois/Search.vue"),
        permission: "Manage WHOIS",
        group: "leftSidebar",
      },
    },
    {
      path: "/vmware",
      component: () => import("@/views/vmware/Index.vue"),
      children: [
        {
          path: "vcenter",
          component: () => import("@/views/vmware/vcenter/Index.vue"),
          name: "vmware.vcenter.index",
          children: [],
          meta: {
            auth: true,
            title: "VCenter",
            label: "VCenter",
            permission: "Manage VMWare",
            children: { path: "vmware/vcenter/menu" },
          },
        },
      ],
      meta: {
        auth: true,
        title: "VMWare",
        label: "VMWare",
        group: "leftSidebar",
        permission: "Manage VMWare",
      },
    },
    {
      path: '/pingdom',
      component: () => import('@/views/pingdom/Index.vue'),
      children: [
        {
          path: 'checks',
          name: 'pingdom.checks.index',
          component: () => import('@/views/pingdom/Checks.vue'),
          meta: {
            auth: true,
            title: 'Checks',
            label: 'Checks',
            permission: 'Manage Pingdom',
          }
        }
      ],
      meta: {
        auth: true,
        title: 'Pingdom',
        label: 'Pingdom',
        group: 'leftSidebar',
        permission: 'Manage Pingdom',
      }
    },
    {
      path: "/tools",
      component: () => import("@/views/tools/Index.vue"),
      children: [
        {
          path: "dns_info",
          name: "tools.dnsinfo.index",
          meta: {
            auth: true,
            title: "DNS Info",
            label: "DNS Info",
            permission: "Manage DNS Info",
            modal: () => import("@/views/tools/DNSInfo.vue"),
          },
        },
        {
          path: 'abr_lookup',
          name: 'tools.abr_lookup.index',
          meta: {
            auth: true,
            title: 'ABR Lookup',
            label: 'ABR Lookup',
            permission: 'Manage ABR',
            modal: () => import('@/views/tools/ABRLookup.vue'),
          }
        }
      ],
      meta: {
        auth: true,
        title: "Tools",
        label: "Tools",
        group: "leftSidebar",
      },
    },
    {
      path: "/powerdns",
      component: () => import("@/views/powerdns/Index.vue"),
      children: [
        {
          path: "domains",
          component: () => import("@/views/powerdns/Domains.vue"),
          name: "powerdns.domains.index",
          meta: {
            auth: true,
            title: "PowerDNS Domains",
            label: "Domains",
            permission: "Manage PowerDNS",
          },
        },
      ],
      meta: {
        auth: true,
        title: "PowerDNS",
        label: "PowerDNS",
        group: "leftSidebar",
      },
    },
    {
      path: "/phpipam",
      component: () => import("@/views/phpipam/Index.vue"),
      children: [
        {
          path: "l2-domains",
          component: () => import("@/views/phpipam/L2Domains.vue"),
          name: "phpipam.l2domains.index",
          meta: {
            auth: true,
            title: "PHPIPAM L2 Domains",
            label: "L2 Domains",
            permission: "Manage PHPIPAM",
          },
        },
        {
          path: "vlans",
          component: () => import("@/views/phpipam/VLANs.vue"),
          name: "phpipam.vlans.index",
          meta: {
            auth: true,
            title: "PHPIPAM VLANs",
            label: "VLANs",
            permission: "Manage PHPIPAM",
          },
        },
        {
          path: "subnets",
          component: () => import("@/views/phpipam/Subnets.vue"),
          name: "phpipam.subnets.index",
          meta: {
            auth: true,
            title: "PHPIPAM Subnets",
            label: "Subnets",
            permission: "Manage PHPIPAM",
          },
        },
      ],
      meta: {
        auth: true,
        label: "PHPIPAM",
        group: "leftSidebar",
      },
    },
    {
      path: "/whmcs",
      component: () => import("@/views/whmcs/Index.vue"),
      children: [
        {
          path: "clients",
          component: () => import("@/views/whmcs/Clients.vue"),
          name: "whmcs.clients.index",
          meta: {
            auth: true,
            title: "WHMCS Clients",
            label: "Clients",
            permission: "Manage WHMCS",
          },
        },
        {
          path: "products",
          component: () => import("@/views/whmcs/Products.vue"),
          name: "whmcs.products.index",
          meta: {
            auth: true,
            title: "WHMCS Products",
            label: "Products",
            permission: "Manage WHMCS",
          },
        },
      ],
      meta: {
        auth: true,
        label: "WHMCS",
        group: "leftSidebar",
      },
    },
    {
      path: "/unifi",
      component: () => import("@/views/unifi/Index.vue"),
      children: [
        {
          path: "sites",
          component: () => import("@/views/unifi/Sites.vue"),
          name: "unifi.sites.index",
          meta: {
            auth: true,
            title: "UniFi Sites",
            label: "Sites",
            permission: "Manage UniFi",
          },
        },
      ],
      meta: {
        auth: true,
        label: "UniFi",
        group: "leftSidebar",
      },
    },
    {
      path: "/rhipe",
      component: () => import("@/views/rhipe/Index.vue"),
      children: [
        {
          path: "microsoftcsp",
          component: () => import("@/views/rhipe/microsoftcsp/Index.vue"),
          children: [
            {
              path: "tenants",
              name: "rhipe.microsoftcsp.tenants.index",
              component: () => import("@/views/rhipe/microsoftcsp/Tenants.vue"),
              meta: {
                auth: true,
                title: "Microsoft CSP Tenants",
                label: "Tenants",
                permission: "Manage Rhipe",
              },
            },
          ],
          meta: {
            title: "Microsoft CSP",
            label: "Microsoft CSP",
            permission: "Manage Rhipe",
          },
        },
        {
          path: "programs",
          name: "rhipe.programs.index",
          component: () => import("@/views/rhipe/Programs.vue"),
          meta: {
            auth: true,
            title: "Rhipe Programs",
            label: "Programs",
            permission: "Manage Rhipe",
          },
        },
        {
          path: "customers",
          name: "rhipe.customers.index",
          component: () => import("@/views/rhipe/Customers.vue"),
          meta: {
            auth: true,
            title: "Rhipe Customers",
            label: "Customers",
            permission: "Manage Rhipe",
          },
        },
        {
          path: "contract-agreements",
          name: "rhipe.contract.agreements.index",
          component: () => import("@/views/rhipe/ContractAgreements.vue"),
          meta: {
            auth: true,
            title: "Rhipe Contract Agreements",
            label: "Contract Agreements",
            permission: "Manage Rhipe",
          },
        },
        {
          path: "products",
          name: "rhipe.products.index",
          component: () => import("@/views/rhipe/Products.vue"),
          meta: {
            auth: true,
            title: "Rhipe Products",
            label: "Products",
            permission: "Manage Rhipe",
          },
        },
      ],
      meta: {
        auth: true,
        title: "Rhipe",
        label: "Rhipe",
        group: "leftSidebar",
        permission: "Manage Rhipe",
      },
    },
    {
      path: "/cloudflare",
      component: () => import("@/views/cloudflare/Index.vue"),
      children: [
        {
          path: "accounts",
          name: "cloudflare.accounts.index",
          component: () => import("@/views/cloudflare/Accounts.vue"),
          meta: {
            label: "Accounts",
            title: "Cloudflare Accounts",
            permission: "Manage Cloudflare",
          },
        },
      ],
      meta: {
        auth: true,
        title: "Cloudflare",
        label: "Cloudflare",
        group: "leftSidebar",
        permission: "Manage Cloudflare",
      },
    },
    {
      path: "/connectwise",
      component: () => import("@/views/connectwise/Index.vue"),
      children: [
        {
          path: "companies",
          name: "connectwise.companies.index",
          component: () => import("@/views/connectwise/Companies.vue"),
          meta: {
            label: "Companies",
            title: "ConnectWise Companies",
            permission: "Manage ConnectWise",
          },
        },
        {
          path: "tickets",
          name: "connectwise.tickets.index",
          component: () => import("@/views/connectwise/Tickets.vue"),
          meta: {
            label: "Tickets",
            title: "ConnectWise Tickets",
            permission: "Manage ConnectWise",
          },
        },
      ],
      meta: {
        label: "ConnectWise",
        group: "leftSidebar",
        permission: "Manage ConnectWise",
      },
    },
    {
      path: "/nable",
      component: () => import("@/views/nable/Index.vue"),
      children: [
        {
          path: "issues",
          name: "nable.issues.index",
          component: () => import("@/views/nable/ActiveIssues.vue"),
          meta: {
            label: "Active Issues",
            title: "N-Able Active Issues",
            permission: "Manage N-Able",
          },
        },
        {
          path: "customers",
          name: "nable.customers.index",
          component: () => import("@/views/nable/Customers.vue"),
          meta: {
            label: "Customers",
            title: "N-Able Customers",
            permission: "Manage N-Able",
          },
        },
        {
          path: "devices",
          name: "nable.devices.index",
          component: () => import("@/views/nable/Devices.vue"),
          meta: {
            label: "Devices",
            title: "N-Able Devices",
            permission: "Manage N-Able",
          },
        },
      ],
      meta: {
        label: "N-Able",
        group: "leftSidebar",
        permission: "Manage N-Able",
      },
    },
    {
      path: "/aws",
      component: () => import("@/views/aws/Index.vue"),
      children: [
        {
          path: "lightsail",
          component: () => import("@/views/aws/lightsail/Index.vue"),
          children: [
            {
              path: "instances",
              name: "aws.lightsail.instances.index",
              component: () => import("@/views/aws/lightsail/Instances.vue"),
              meta: {
                title: "Lightsail Instances",
                label: "Instances",
                permission: "Manage AWS Lightsail",
              },
            },
          ],
          meta: {
            label: "Lightsail",
            permission: "Manage AWS Lightsail",
          },
        },
        {
          path: "route53",
          component: () => import("@/views/aws/route53/Index.vue"),
          children: [
            {
              path: "hostedzones",
              name: "aws.route53.hostedzones.index",
              component: () => import("@/views/aws/route53/HostedZones.vue"),
              meta: {
                title: "Route53 Hosted Zones",
                label: "Hosted Zones",
                permission: "Manage AWS Route53",
              },
            },
          ],
          meta: {
            label: "Route53",
            permission: "Manage AWS Route53",
          },
        },
      ],
      meta: {
        label: "Aws",
        group: "leftSidebar",
      },
    },
    {
      path: "/radius",
      component: () => import("@/views/freeradius/Index.vue"),
      children: [
        {
          path: "",
          name: "freeradius.checks.index",
          component: () => import("@/views/freeradius/checks/Index.vue"),
          meta: {
            auth: true,
            title: "Radius Users",
            label: "Users",
            permission: "Manage Radius",
          },
        },
        {
          path: "online",
          name: "freeradius.accounts.online",
          component: () => import("@/views/freeradius/accounts/Online.vue"),
          meta: {
            auth: true,
            title: "Online Radius Users",
            label: "Online",
            permission: "Manage Radius",
          },
        },
        {
          path: "accounting",
          name: "freeradius.accounts.index",
          component: () => import("@/views/freeradius/accounts/Index.vue"),
          meta: {
            auth: true,
            title: "Radius Accounting",
            label: "Accounting",
            permission: "Manage Radius",
          },
        },
        {
          path: "history",
          name: "freeradius.auth.index",
          component: () => import("@/views/freeradius/auth/Index.vue"),
          meta: {
            auth: true,
            title: "    Radius Login History",
            label: "Login History",
            permission: "Manage Radius",
          },
        },
      ],
      meta: {
        title: "Radius",
        label: "Radius",
        group: "leftSidebar",
        index: 3,
      },
    },
    {
      path: "/lmail",
      component: () => import("@/views/postfix/Index.vue"),
      children: [
        {
          path: "mailboxes",
          name: "postfix.mailboxes.index",
          component: () => import("@/views/postfix/mailboxes/Index.vue"),
          meta: {
            auth: true,
            title: "Mailboxes",
            label: "Mailboxes",
            permission: "Manage Mail",
          },
        },
        {
          path: "domains",
          name: "postfix.domains.index",
          component: () => import("@/views/postfix/domains/Index.vue"),
          meta: {
            auth: true,
            title: "Domains",
            label: "Domains",
            permission: "Manage Mail",
          },
        },
        {
          path: "aliases",
          name: "postfix.aliases.index",
          component: () => import("@/views/postfix/aliases/Index.vue"),
          meta: {
            auth: true,
            title: "Aliases",
            label: "Aliases",
            permission: "Manage Mail",
          },
        },
        {
          path: "logs",
          name: "postfix.logs.index",
          component: () => import("@/views/postfix/logs/Index.vue"),
          meta: {
            auth: true,
            title: "Logs",
            label: "Logs",
            permission: "Manage Mail",
          },
        },
      ],
      meta: {
        title: "LMail",
        label: "LMail",
        group: "leftSidebar",
        index: 4,
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("@/views/Settings.vue"),
      meta: {
        auth: true,
        title: "Settings",
        label: "Settings",
        group: "leftSidebar",
        index: 99,
        cssClass: "md:hidden",
      },
    },
    {
      path: "/sip",
      component: () => import("@/views/sip/Index.vue"),
      children: [
        {
          path: "rules",
          name: "sip.rules.index",
          component: () => import("@/views/sip/Rules.vue"),
          meta: {
            auth: true,
            title: "SIP Rules",
            label: "Rules",
            permission: "Manage SIP",
          },
        },
        {
          path: "gateways",
          name: "sip.gateways.index",
          component: () => import("@/views/sip/Gateways.vue"),
          meta: {
            auth: true,
            title: "SIP Gateways",
            label: "Gateways",
            permission: "Manage SIP",
          },
        },
        {
          path: "cdr",
          name: "sip.cdr.index",
          component: () => import("@/views/sip/CallDetails.vue"),
          meta: {
            auth: true,
            title: "SIP Call Detail Records",
            label: "Call Detail Records",
            permission: "Manage SIP",
          },
        },
      ],
      meta: {
        auth: true,
        title: "SIP PROXY",
        label: "SIP PROXY",
        group: "leftSidebar",
      },
    },
    {
      path: "/admin",
      component: () => import("@/views/admin/Index.vue"),
      children: [
        {
          path: "",
          name: "admin.apps.index",
          component: () => import("@/views/admin/apps/Index.vue"),
          meta: {
            auth: true,
            title: "Applications",
            label: "Applications",
            permission: "Manage Applications",
          },
        },
        {
          path: "users",
          name: "admin.users.index",
          component: () => import("@/views/admin/users/Index.vue"),
          meta: {
            auth: true,
            title: "Users",
            label: "Users",
            permission: "Manage Users",
          },
        },
        {
          path: "roles",
          name: "admin.roles.index",
          component: () => import("@/views/admin/roles/Index.vue"),
          meta: {
            auth: true,
            title: "Roles",
            label: "Roles",
            permission: "Manage Roles",
          },
        },
        {
          path: "permissions",
          name: "admin.permissions.index",
          component: () => import("@/views/admin/permissions/Index.vue"),
          meta: {
            auth: true,
            title: "Permissions",
            label: "Permissions",
            permission: "Manage Permissions",
          },
        },
        {
          path: "logs",
          name: "admin.logs.index",
          component: () => import("@/views/admin/logs/Index.vue"),
          meta: {
            auth: true,
            title: "Logs",
            label: "Logs",
            permission: "Manage Logs",
          },
        },
        {
          path: "providers",
          name: "admin.providers.index",
          component: () => import("@/views/admin/providers/Index.vue"),
          meta: {
            auth: true,
            title: "Providers",
            label: "Providers",
            permission: "Manage Providers",
          },
        },
        {
          path: "horizon",
          name: "horizon",
          meta: {
            auth: true,
            label: "Horizon",
            permission: "Manage Horizon",
            url: process.env.VUE_APP_API_URL + "/horizon",
          },
        },
        {
          path: "telescope",
          name: "telescope",
          meta: {
            auth: true,
            label: "Telescope",
            permission: "Manage Telescope",
            url: process.env.VUE_APP_API_URL + "/telescope",
          },
        },
        {
          path: "docs",
          name: "docs",
          meta: {
            auth: true,
            label: "Docs",
            permission: "Manage Docs",
            url: process.env.VUE_APP_API_URL + "/docs",
          },
        },
      ],
      meta: {
        admin: true,
        title: "Admin",
        label: "Admin",
        group: "leftSidebar",
        index: 98,
      },
    },
    {
      path: "/tpp",
      component: () => import("@/views/tpp/Index.vue"),
      children: [
        {
          path: "domains",
          name: "tpp.domains.index",
          component: () => import("@/views/tpp/Domains.vue"),
          meta: {
            auth: true,
            title: "TPP Domains",
            label: "Domains",
            permission: "Manage TPP",
          },
        },
      ],
      meta: {
        auth: true,
        title: "TPP",
        label: "TPP",
        group: "leftSidebar",
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { guest: true },
    },
    {
      path: "/password/remind",
      name: "password.remind",
      component: PasswordRemind,
      meta: { guest: true },
    },
    {
      path: "/password/reset/:token",
      name: "password.reset",
      component: PasswordReset,
      meta: { guest: true },
    },
    {
      path: "/cpanel",
      name: "cpanel.index",
      component: () => import("@/views/cpanel/Index.vue"),
      meta: {
        auth: true,
        title: "Cpanel Servers",
        label: "Cpanel",
        group: "leftSidebar",
        permission: "Manage Cpanel",
      },
    },
    {
      path: "/cachet",
      name: "cachet.index",
      component: () => import("@/views/cachet/Index.vue"),
      meta: {
        auth: true,
        title: "Cachet Clients",
        label: "Cachet",
        group: "leftSidebar",
        permission: "Manage Cachet",
      },
    },
    {
      path: "/sms",
      name: "sms.index",
      component: () => import("@/views/sms/Index.vue"),
      meta: {
        auth: true,
        title: "SMS",
        label: "SMS",
        group: "leftSidebar",
        permission: "Manage SMS",
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        auth: true,
        label: "Logout",
        group: "leftSidebar",
        cssClass: "md:hidden",
      },
    },
    {
      path: "*",
      redirect: { name: "dashboard" },
      meta: {},
    },
  ],
});

router.beforeEach((to, from, next) => {
    const user = store.getters['auth/user'];

    const requiresAuth = to.matched.some((record) => record.meta.auth);
    const requiresAdmin = to.matched.some((record) => record.meta.admin);
    const requiresGuest = to.matched.some((record) => record.meta.guest);
    const permission = to.meta.permission;

    if (!user) {
        store.commit('setLoading', true);
        store.dispatch('auth/setUser')
        .then(({ data }) => {
            store.commit('setLoading', false);

            if (
                requiresGuest ||
                (permission && data.permissions.findIndex(i => i.name === permission) === -1 && !data.super_admin)
            ) {
                next({ name: 'dashboard' });
                return;
            }
            
            next();
        })
        .catch(({ response }) => {
            store.commit('setLoading', false);
            if (requiresAuth) {
                next({ name: 'login' });
                return
            }   

            next();
        });
    } else if (user && to.name !== 'dashboard' && requiresGuest) {
        next({ name: 'dashboard' });
    } else { 
        if (
            (permission && user.permissions.findIndex(i => i.name === permission) === -1 && !user.super_admin)
        ) {
            next({ name: 'dashboard' });
            return;
        }

        next();
    }
});

export default router;
